import { useUserSaveType } from "@/app/layout/useUserSaves";
import {
  Box,
  CircularProgress,
  IconButton,
  MenuItem,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Link from "next/link";
import { EmailSubscriptionSwitch } from "@/components/common/EmailSubscriptionSwitch";
import { UserSaveType } from "@/backend/user/models/UserSave";

function BlockClickEvent(event: React.MouseEvent) {
  event.stopPropagation();
  event.preventDefault();
  event.nativeEvent.stopImmediatePropagation();
}

export function SavesList({
  type,
  currentKey,
}: {
  type: UserSaveType;
  currentKey?: string;
}) {
  const { userSaves, status, RemoveUserSave, ToggleSubscribed } =
    useUserSaveType(type);
  return (
    <>
      {status !== "ready" ? (
        <CircularProgress
          sx={{
            alignSelf: "center",
            margin: 2,
          }}
        />
      ) : (
        <>
          {userSaves.length === 0 ? (
            <Typography>
              You don&apos;t have any saved {type.toLowerCase()}s.
            </Typography>
          ) : (
            <>
              {userSaves.map((save) => {
                if (!save.url || !save.title) return null;
                return (
                  <MenuItem
                    key={save.key}
                    component={Link}
                    href={save.url}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight:
                          currentKey && currentKey === save.key
                            ? "bold"
                            : "normal",
                        whiteSpace: "normal",
                      }}
                    >
                      {save.title}
                    </Typography>
                    <Box
                      sx={{
                        marginLeft: "auto",
                      }}
                    >
                      <EmailSubscriptionSwitch
                        onClick={async (e) => {
                          BlockClickEvent(e);
                          await ToggleSubscribed(save.key);
                        }}
                        checked={!save.isUnsubscribed}
                      />
                    </Box>
                    <IconButton
                      onClick={async (e) => {
                        BlockClickEvent(e);
                        await RemoveUserSave(save.key);
                      }}
                      sx={{
                        margin: -1,
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </MenuItem>
                );
              })}
            </>
          )}
        </>
      )}
    </>
  );
}
